<h3>Total including postage</h3>

<div class="shipping-item">
  <p>Subtotal: <span>{{ subtotal | currency:'GBP' }}</span></p>
  <p>Shipping ({{displayRate}}): {{shipping | currency:'GBP'}}</p>

</div> 

<div class="shipping-item">
	<p><b>Total to pay: {{shipping+subtotal | currency:'GBP'}}</b></p>
</div>
<!--button (click)="purchase()" class="button" type="submit">Go to payment...</button-->
<div>
	<button mat-raised-button color="primary" [class.spinner]="loading" [disabled]="loading" (click)="purchase()">purchase</button>
</div>

<div class="result">
	<p>{{errorMsg}}</p>
</div>


<!-- We use the async pipe to automatically subscribe/unsubscribe to our observable 
<div class="payment" *ngIf="(purchase$ | async).length">
    <p class="payment_result" *ngFor="let result of purchase$ | async">
        {{ result }}
    </p>
</div>-->